import { Icon } from '@iconify/react';
import { FeatureKey } from 'common/constants/permission';
import { PATH_DASHBOARD } from 'routes/paths';

export interface NavbarMenuItem {
  icon: string;
  label: string;
  onClick?: (navigate: (path: string) => void) => void;
  endIcon?: React.ReactNode;
  children?: {
    label: string;
    path: string;
  }[];
  permission?: FeatureKey;
  featureFlag?: string;
}

export const NAVBAR_MENU: NavbarMenuItem[] = [
  {
    icon: '/static/icons/OrganizationOverview/Organization.svg ',
    label: 'organizationOverview',
    onClick: (navigate) => { navigate(PATH_DASHBOARD.organization.root); },
    permission: FeatureKey.OrganizationDashboard,
    featureFlag: 'ORG_OVERVIEW',
  },
  {
    icon: '/static/icons/layout/iot.svg',
    label: 'iot',
    onClick: (navigate) => { navigate(PATH_DASHBOARD.iot.root); },
    permission: FeatureKey.Iot,
    featureFlag: 'IOT_DEVICE',
  },
  {
    icon: '/static/icons/layout/compress.svg',
    label: 'compare',
    onClick: (navigate) => { navigate(PATH_DASHBOARD.comparison.root); },
    permission: FeatureKey.PondComparison,
  },
  {
    icon: '/static/icons/layout/price.svg',
    label: 'shrimpPrice',
    onClick: (navigate) => { navigate(PATH_DASHBOARD.shrimpPrice.root); },
  },
  {
    icon: '/static/icons/layout/employee.svg',
    label: 'employee',
    endIcon: <Icon icon="mdi:chevron-down" width={20} height={20} />,
    children: [
      { label: 'employeeList', path: PATH_DASHBOARD.members.list },
      { label: 'accessRights', path: PATH_DASHBOARD.members.roles },
    ],
  },
  {
    icon: '/static/icons/layout/garage.svg',
    label: 'garage',
    permission: FeatureKey.Inventory,
    onClick: (navigate) => { navigate(PATH_DASHBOARD.inventory.product); },
  },
];
